import { jewelleryTryOnHref, jewelleryCardDisplayName, isJewelleryTryOnProduct } from '../../../app/Libraries/JewelleryTryOn';

import { productCardCTA, isProtectedCardProduct } from '../../../app/Libraries/ProductCardAvailability';

const escape = (value: unknown): string => String(value == null ? '' : value).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character] || character));

/** Catalogue layout does not depend on optional try-on classification. */
export function isNativeJewelleryCatalogueHit(hit: any, pagePath = ''): boolean {
  return !!hit && !isProtectedCardProduct(hit, pagePath);
}

/** Real catalogue markup, shared with offline checks. No camera or watch state hooks. */
export function jewelleryCatalogueCard(hit: any, productUrl: string, image: {url: string; srcSet: string}, priceMarkup: string, locale: string, copy: {shopNow: string; inquireAvailability: string; tryOn: string; comingSoon: string}, extraClass = '', pagePath = '', allowTryOn = true): string {
  const action = productCardCTA(hit, productUrl, pagePath);
  const brand = String(hit.named_tags?.brand || hit.vendor || '');
  const title = String(hit.title || '');
  const displayName = jewelleryCardDisplayName(title, brand);
  const reference = String(hit.sku || '').trim();
  const canTryOn = allowTryOn && isNativeJewelleryCatalogueHit(hit, pagePath) && isJewelleryTryOnProduct({ ...hit, productType: hit.product_type, brand });
  const tryOnUrl = canTryOn ? jewelleryTryOnHref(hit.handle, hit.objectID, locale) : '';
  return `<li class="collection__grid-item rf-native-piece-item${escape(extraClass)}">
    <article class="product-card rf-native-piece-card js-product" ${canTryOn ? 'data-jewellery-card' : 'data-piece-card'}
      data-product="${escape(hit.handle)}" data-position="${escape(hit.__position)}" data-query-id="${escape(hit.__queryID)}" data-object-id="${escape(hit.objectID)}">
      <a href="${escape(productUrl)}" class="product-card__images" tabindex="-1" aria-hidden="true">
        <img class="product-card__img product-card__img--primary lazyload" alt="" data-src="${escape(image.url)}" data-srcset="${escape(image.srcSet)}" decoding="async" />
      </a>
      <div class="product-card__details">
        <p class="product-card__brand-line">${escape(brand)}</p>
        <h3 class="product-card__title"><a href="${escape(productUrl)}">${escape(displayName)}</a></h3>
        <p class="product-card__spec-line">${reference ? `<span class="rf-native-watch-reference">${locale === 'fr' ? 'Réf.' : 'Ref.'} ${escape(reference)}</span>` : ''}</p>
        ${priceMarkup}
        <div class="rf-piece-card-actions">
          <a href="${escape(action.href)}" class="rf-piece-shop">${escape(action.inquiry ? copy.inquireAvailability : copy.shopNow)}</a>
          ${tryOnUrl ? `<a href="${escape(tryOnUrl)}" class="rf-jewellery-tryon" aria-label="${escape(copy.tryOn)} — ${escape(copy.comingSoon)}: ${escape(displayName)}">${escape(copy.tryOn)}</a>` : ''}
        </div>
      </div>
    </article>
  </li>`;
}
